export default {"src":"/_next/static/media/date.8985d9c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};